import { useQuery } from '@tanstack/react-query'

import API from '../../../utils/api'

export const useCatalogRecomended = () => {
  const { data, isLoading, refetch, error } = useQuery(
    ['/GamesCatalog/recommended'],
    API.getRecommendedGames,
    {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )

  return {
    games: data?.data?.games || [],
    refetch,
    error,
    isLoading,
  }
}
